import React from 'react';
import { TextField } from '@mui/material';
import InputMask from 'react-input-mask';

const MaskCep = ({ label, type, errorText, onChange, mask, value }) => {
    return (
        <InputMask mask={mask} value={value} onChange={onChange}> 
            {(inputProps) => (
                <TextField
                    label={label}
                    value={value}
                    variant="outlined"
                    InputLabelProps={label}
                    type={type}
                    error={errorText}
                    helperText={errorText}
                    margin='dense'
                    minRows={1}
                    maxRows={1}
                    fullWidth
                    inputProps={{ readOnly: false, ...inputProps,}}
                />
            )}
        </InputMask>
    );
};

export default MaskCep;
